import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, MessageCircle } from "lucide-react";
import { waHref } from "@/data/site";

const MEMBERS = [
  {
    slug: "sevda-karatas",
    name: "Sevda Karataş",
    title: "Uzman Estetisyen — Usta Öğretici",
    image: "/upload/team/sevda-karatas-card.jpg",
    blurb: "Cilt bakımı ve lazer epilasyonda yılların pratiği; annelik özeniyle sıcak hizmet.",
    badges: ["Cilt Bakımı", "Lazer Epilasyon"],
    waMessage: "Sevda Karataş ile cilt bakımı için randevu almak istiyorum.",
  },
  {
    slug: "serdar-ceylan",
    name: "Serdar Ceylan",
    title: "Podolog — Usta Öğretici",
    image: "/upload/team/serdar-ceylan-card.jpg",
    blurb: "Podoloji, medikal ayak bakımı ve estetik uygulamalarını tek çatı altında buluşturan öncü isim.",
    badges: ["Podolog", "Usta Öğretici"],
    waMessage: "Serdar Ceylan ile podoloji için danışma randevusu almak istiyorum.",
  },
  {
    slug: "selin-salur",
    name: "Selin Salur",
    title: "Master Nail Technician",
    image: "/upload/team/selin-salur.webp",
    blurb: "Modern protez tırnak, Rus manikür teknikleri ve medikal pedikürde uzman dokunuş.",
    badges: ["Protez Tırnak", "Rus Manikür"],
    waMessage: "Selin Salur ile protez tırnak ve medikal pedikür için randevu almak istiyorum.",
  },
  {
    slug: "semih-ceylan",
    name: "Semih Ceylan",
    title: "Epilasyon Uzmanı",
    image: "/upload/team/semih-ceylan.webp",
    blurb: "MYK Seviye 4 belgeli, kişiye özel planlama ve seans takibiyle profesyonel erkek lazer epilasyon.",
    badges: ["Erkek Lazer Epilasyon", "MYK Seviye 4"],
    waMessage: "Semih Ceylan ile erkek lazer epilasyon için randevu almak istiyorum.",
  },
];

export default function TeamPreview() {
  return (
    <section data-testid="home-team-preview" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-10 md:gap-12 items-end mb-12">
          <div className="md:col-span-2">
            <p className="chip-green mb-4">Ekibimiz</p>
            <h2 className="font-display text-3xl md:text-5xl text-[#0B1B33] leading-[1.05] tracking-tight">
              Alanında uzman, <span className="italic text-[#4F8B2A]">sıcak</span> ellerdesiniz.
            </h2>
            <p className="text-[#4B5A6E] mt-5 max-w-2xl leading-relaxed text-base md:text-lg">
              Podolojiden estetiğe uzanan yolculuğunuzda; yıllarını mesleğine adamış, hijyen ve bilimsel yaklaşımı esas alan bir kadro yanınızda.
            </p>
          </div>
          <div className="md:text-right">
            <Link to="/hakkimizda#ekibimiz" className="inline-flex items-center gap-2 text-sm font-semibold text-[#4F8B2A] hover:text-[#3F7A2E] tracking-wide">
              Tüm Ekibi Tanı <ArrowRight size={16} />
            </Link>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-10 items-stretch">
          {MEMBERS.map((m) => (
            <article
              key={m.name}
              data-testid={`team-card-${m.name.split(" ")[0].toLowerCase()}`}
              className="group relative bg-white border border-[#E5EAF0] rounded-3xl overflow-hidden shadow-sm hover:shadow-2xl hover:-translate-y-1 transition-all duration-500 flex flex-col h-full"
            >
              <div className="grid grid-cols-5 items-stretch flex-1">
                <div className="col-span-2 relative overflow-hidden bg-[#F5F7FA]">
                  <picture>
                    <source srcSet={m.image.replace(/\.(jpg|webp)$/, ".webp")} type="image/webp" />
                    <img
                      src={m.image}
                      alt={`${m.name} - ${m.title}`}
                      width="320"
                      height="400"
                      loading="lazy"
                      decoding="async"
                      className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-[1.04] transition-transform duration-700"
                    />
                  </picture>
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0B1B33]/25 via-transparent to-transparent pointer-events-none"></div>
                </div>
                <div className="col-span-3 p-6 md:p-8 flex flex-col">
                  <p className="text-[10px] tracking-[0.22em] uppercase font-bold text-[#4F8B2A] mb-2">{m.title}</p>
                  <h3 className="font-display text-2xl md:text-3xl text-[#0B1B33] tracking-tight leading-tight mb-3">{m.name}</h3>
                  <p className="text-[#4B5A6E] text-sm md:text-[15px] leading-relaxed mb-5">{m.blurb}</p>
                  <div className="flex flex-wrap gap-2 mb-6">
                    {m.badges.map((b) => (
                      <span key={b} className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#6CA320]/10 text-[#3F7A2E] text-[11px] font-semibold tracking-wide">
                        <ShieldCheck size={12} /> {b}
                      </span>
                    ))}
                  </div>
                  <div className="mt-auto flex flex-wrap gap-2">
                    <a
                      href={waHref(m.waMessage)}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center gap-1.5 h-9 px-4 rounded-full bg-[#10B981] text-white text-[11px] tracking-[0.14em] uppercase font-bold hover:brightness-110 transition"
                    >
                      <MessageCircle size={12} /> Uzmana Yaz
                    </a>
                    <Link
                      to={`/hakkimizda#${m.slug}`}
                      className="inline-flex items-center gap-1.5 h-9 px-4 rounded-full border border-[#0B1B33]/20 text-[#0B1B33] text-[11px] tracking-[0.14em] uppercase font-bold hover:bg-[#0B1B33] hover:text-white transition"
                    >
                      Tanı <ArrowRight size={12} />
                    </Link>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
